export const GENERIC_INSIGHTS_ERROR =
  'Something went wrong answering that. Please try again in a moment.';

// Turn a raw backend error message into a friendlier, actionable line for the
// chat. The agent only surfaces a short string, so we match on the known error
// shapes the function throws (timeout, auth, budget) and fall back to generic.
const categorizeInsightsError = (message?: string): string => {
  const lower = (message ?? '').toLowerCase();

  if (lower.includes('timed out') || lower.includes('timeout')) {
    return 'That took too long to answer. Try a narrower question — a shorter date range or fewer breakdowns.';
  }
  // A raw fetch/stream rejection (network failure, CORS block, dropped SSE
  // connection) rather than a backend `error` message. The browser surfaces
  // these as "Failed to fetch" / "NetworkError" / "Load failed".
  if (
    lower.includes('failed to fetch') ||
    lower.includes('networkerror') ||
    lower.includes('network error') ||
    lower.includes('load failed') ||
    lower.includes('network request failed')
  ) {
    return 'Could not reach the Insights service. Check your connection and try again.';
  }
  if (
    lower.includes('budget') ||
    lower.includes('429') ||
    lower.includes('limit reached')
  ) {
    return "You've reached your AI usage limit for this period. It resets at the start of next month.";
  }
  if (
    lower.includes('401') ||
    lower.includes('403') ||
    lower.includes('unauthorized') ||
    lower.includes('forbidden') ||
    lower.includes('authorization')
  ) {
    return 'Your session may have expired. Please refresh the page and try again.';
  }
  return GENERIC_INSIGHTS_ERROR;
};

export default categorizeInsightsError;
